import { VariantTitle } from "../../components/VariantTitle";
import { PivotSection } from "../../components/PivotSection";
import { formatCTAS, formatRichText, contentfulToImageData } from "../../functions";
import { CTAWrapper } from "../../components/CTA/CTAWrapper";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { formatInfoCards } from "../info_card/formatInfoCards";
import { INFO_CARD_VARIANTS } from "../../constants";
import { NonStaticComponents } from "../../components/NonStaticComponents";
import Carousel from "../../components/Carousel";

export const TabPivotPageSection = ({
  tabPivotTable,
  headerText,
  description,
  subTitle,
  variant,
  siteStatus,
  isStatic = false,
}) => {
  const pivotData = tabPivotTable.map(({ fields }) => {
    const { tabContent, cta, tabHeaderText, tabHeaderIcon, title, nonStaticComponentIds, nonStaticComponentLabel } = fields;
    return {
      tabHeaderTitle: tabHeaderText ?? title,
      tabHeaderIcon: tabHeaderIcon ? contentfulToImageData(tabHeaderIcon) : null,
      render: () => (
        <TabPivotPanel
          content={tabContent}
          variant={variant}
          cta={formatCTAS(cta, siteStatus, isStatic)}
          siteStatus={siteStatus}
          nonStaticComponentIds={nonStaticComponentIds}
          nonStaticComponentLabel={nonStaticComponentLabel}
          isStatic={isStatic}
        />
      ),
    };
  });

  const formattedDescription = description && (
    <div className="my-4 text-center text-is2-gray-150">
      {formatRichText(description, siteStatus, [], {}, isStatic)}
    </div>
  );

  return (
    <PageSectionWrapper variant={variant}>
      <VariantTitle
        title={headerText}
        subtitle={subTitle}
        parsedClasses="md:text-center"
        description={formattedDescription}
      />

      {pivotData?.length > 0 && <PivotSection pivotData={pivotData} />}
    </PageSectionWrapper>
  );
};
const renderContent = (content, siteStatus) => {
  const infoCards = content.filter(item =>
    item.sys?.contentType?.sys?.id === "infoCard"
  );

  if (infoCards.length > 0) {
    return (
      <Carousel
        items={formatInfoCards(infoCards, INFO_CARD_VARIANTS.CAROUSEL_CARD, {}, [], siteStatus)}
        config={{ carouselOnDesktop: false, columnCount: infoCards.length }}
      />
    );
  }

  return (
    <div className="flex flex-col gap-8 md:flex-row py-8 lg:divide-x divide-is2-blue-50 border-b border-is2-blue-50 mx-8">
      {content?.map((item, index) => {
        const { title, paragraph } = item.fields;
        if (!title || !paragraph) {
          console.warn(`TabPivotPanel: Missing title or paragraph in content at index ${index}`);
          return null;
        }
        return (
          <div key={index} className={`flex items-start gap-4 first:pl-0 lg:pl-8 md:w-1/${content.length}`}>
            <span className="font-bold text-xl">{index + 1}.</span>
            <div className="[&_p]:text-gray-700 text-left">
              <p className="mb-4"><strong>{title}</strong></p>
              {documentToReactComponents(paragraph)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const TabPivotPanel = ({ content, cta, variant, siteStatus, nonStaticComponentIds, nonStaticComponentLabel, isStatic }) => {
  return (
    <div
      className={`flex flex-col gap-8 rounded-[32px] pb-8 max-w-[1124px] mx-auto ${variant === "normal" ? "bg-is2-yellow-100" : "bg-white"
        }`}
    >
      {renderContent(content, siteStatus)}

      {nonStaticComponentIds?.length > 0 && (
        <div className="max-w-[400px] mx-auto -mb-4">
          <NonStaticComponents
            componentId={nonStaticComponentIds[0]}
            isStatic={isStatic}
            props={{ basic: true, badge: true, color: 'bg-is2-green-150', siteStatus, ...(nonStaticComponentLabel && { label: nonStaticComponentLabel }) }}
          />
        </div>
      )}

      {cta && cta.length > 0 && (
        <div className="flex flex-col gap-4 items-center">
          {cta.map((ctaData) => (
            <CTAWrapper
              key={ctaData.title}
              cta={ctaData}
              parsedClasses="w-full md:max-w-[300px]"
            />
          ))}
        </div>
      )}
    </div>
  );
};
